module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eddies Bastard")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/eddiesbastard_epg#epg"
    }
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/eddiesbastard_ch01#ch01"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("I Am Born; Grandpa Discovers Me, and I Am Named; I Learn to Read; the Ghosts; I Encounter Annie Simpson")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/eddiesbastard_ch02#ch02"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Grandpa’s War Story, as Told to Me by Himself")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("My Early Childhood Continued; the Kind of Man My Father Was; the Munchkins; Grandpa Has an Accident")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("My Seventh Year Continued; I Go to the Shumachers’; I Encounter Trevor and Adam")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("My Thirteenth Year; More of Annie; The Steamroller")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("My Fourteenth Year; I Become a Man; How Willie Found the Money; the Rory Curse; I Become a Writer")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("In Which I Present My Very First Short Story, Entitled “Willie Mann and the Rory Fortune”")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("My Fifteenth Year; I Kill Mr. Simpson")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("My Sixteenth Birthday; I Am Discovered, and Elsie Moves On; Mr. Simpson’s Funeral; Grandpa Gets Better")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("My Sixteenth Year Continued; Middlism; How I Decided to Conquer the World; I Have a New Dream")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Doctor Connor’s Letter, in Which Much Is Explained; I Visit Henry Hutchins")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("My Eighteenth Year; the Next Round of Three; I Bury Frederic Simpson; Grandpa’s Narration, and His Departure")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Grandpa’s Wake; the End of Some Things, and the Beginnings of Others")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1a",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_ack01#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_cop01#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/eddiesbastard_atp01#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e65a62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eddiesbastard_con01.vue
// module id = 69
// module chunks = 0